module.exports = __webpack_public_path__ + "static/media/Arab National Bank, Saudi Arabia .d76d35d8.jpg";